// 头像制作
<template>
	<div class="fs-container">
		<div class="content-show-box" v-if="jumpFlag">
			<div
				:class="['img-s-box', xkSpecial ? 'special-img' : '']"
				ref="data1BoxRef"
			>
				<img
					crossOrigin="anonymous"
					class="bqbj-cla"
					v-if="xkImg"
					:src="xkImg"
				/>
				<img
					crossOrigin="anonymous"
					class="bq-cla"
					v-if="bqImg"
					:class="[
						bqPosition,
						{ 'xygb-bq-img': bqImgId == 6 },
						{ 'fl-bq-img': bqImgId == 7 },
					]"
					:src="bqImg"
				/>
				<!-- { 'xygb-bq-img': bqImgId == 12 },
						{ 'fl-bq-img': bqImgId == 11 },
    height: 12%;

						{ 'ayg-bq-img': bqImgId == 10 }, -->
				<!-- :style="{
						height: xkHeight,
						width: xkWidth,
						top: xkTop,
						left: xkLeft,
						borderRadius: '10px',
						:class="xkTop ? 'txx-img' : ''"
					}" -->
				<div
					v-if="avatarImg"
					:style="{
						height: xkHeight,
						width: xkWidth,
						top: xkTop,
						left: xkLeft,
						borderRadius: '10px',
					}"
				>
					<map-canvas-vue
						ref="mapCnavasRef"
						v-if="avatarImg"
						:imgUrl="avatarImg"
					></map-canvas-vue>
					<!-- <img
						crossOrigin="anonymous"
						style="height: 100%; wdith: 100%"
						:src="avatarImg"
					/> -->
				</div>

				<div
					v-if="!avatarImg"
					:class="xkTop ? 'txx-img' : ''"
					:style="{
						height: xkHeight,
						width: xkWidth,
						top: xkTop,
						left: xkLeft,
						borderRadius: '15px',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}"
				>
					<div class="add-i"></div>
				</div>
			</div>
			<div class="opt-btns">
				<div class="up-btn" @click="useCurrentAvatar"></div>
				<div class="up-btn" @click="uploadImg">
					<input
						type="file"
						name="fileIOS"
						@change="changeImgIOS"
						accept="image/*"
						ref="inputFileRefIOS"
						style="display: none"
					/>
				</div>
			</div>
			<div class="select-box">
				<div class="left-btn" @click="leftClick"></div>
				<div class="sb-box">
					<div class="sb-cbox-warper">
						<Swiper
							style="width: 6rem; position: absolute; top: 0; left: 0rem"
							:options="swiperOption"
							ref="bqSwiperRef"
						>
							<Swiper-slide
								style="
									width: auto;
									height: auto;
									display: flex;
									justify-content: center;
								"
								v-for="item in showBqList"
								:key="item.id"
							>
								<div class="sb-box-wapper">
									<div
										class="img-c"
										v-for="(item, index) in item.arr"
										:key="index"
										@click="bqImgSelect(item)"
									>
										<img
											:src="item.img"
											:style="{
												height: [7, 8, 9, 10, 11, 12].includes(item.id)
													? '33%'
													: '',
											}"
										/>
									</div>
								</div>
							</Swiper-slide>
						</Swiper>
					</div>
				</div>
				<div class="right-btn" @click="rightClick"></div>
			</div>
			<div class="end-btns">
				<div class="btn" @click="callBack"></div>
				<div class="btn" @click="generateNewAvatar"></div>
			</div>
		</div>
		<van-popup v-model="uploadModal" position="bottom">
			<div class="popup-box">
				<div @click="openFile(2)">从相册中选择</div>
				<input
					type="file"
					name="file"
					@change="changeImg(2)"
					accept="image/*"
					ref="inputFileRef"
					style="display: none"
				/>
				<div @click="openFile(1)">拍照</div>
				<input
					type="file"
					name="file"
					@change="changeImg(1)"
					accept="image/*"
					ref="inputFilCameraeRef"
					capture="camera"
					style="display: none"
				/>
			</div>
		</van-popup>
		<!-- 裁剪 -->
		<van-popup
			class="bg-tran"
			v-model="showCropper"
			closeable
			position="top"
			:style="{ height: '100%' }"
		>
			<div
				class="flex-column-center height100"
				style="
					height: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					overflow: hidden;
					width: 100%;
					background: #000;
				"
			>
				<vueCropper
					style="
						background: rgba(0, 0, 0, 0.4);
						overflow: hidden;
						width: calc(100% - 100px);
					"
					ref="cropper"
					:img="option.img"
					:outputSize="option.outputSize"
					:outputType="option.outputType"
					:info="option.info"
					:full="option.full"
					:autoCropWidth="option.autoCropWidth"
					:autoCropHeight="option.autoCropHeight"
					:canMove="option.canMove"
					:canMoveBox="option.canMoveBox"
					:original="option.original"
					:autoCrop="option.autoCrop"
					:fixed="option.fixed"
					:fixedNumber="option.fixedNumber"
					:centerBox="option.centerBox"
					:infoTrue="option.infoTrue"
					:fixedBox="option.fixedBox"
					:high="option.high"
					:mode="option.mode"
					:enlarge="option.enlarge"
				></vueCropper>
				<van-col
					span="24"
					style="
						display: flex;
						justify-content: space-between;
						background: #fff;
					"
				>
					<van-col
						span="10"
						class="p-2"
						style="
							text-align: center;
							height: 70px;
							line-height: 60px;
							font-size: 22px;
						"
						><span @click="cancelCropper">取消</span></van-col
					>
					<van-col
						span="10"
						class="p-2"
						style="
							text-align: center;
							height: 70px;
							line-height: 60px;
							font-size: 22px;
						"
						><span @click="getCropBlob">确定</span></van-col
					>
				</van-col>
			</div>
		</van-popup>
		<div
			id="box1"
			style="transform: translateY(991px); border-radius: 10px"
		></div>
	</div>
</template>
<script>
	// const bq1 = '/style/assets/image/p4/bq/hicetea1@2x.png'
	// const bq2 = '/style/assets/image/p4/bq/hicetea2@2x.png'
	// const bq3 = '/style/assets/image/p4/bq/hicetea3@2x.png'
	// const bq4 = '/style/assets/image/p4/bq/hicetea4@2x.png'
	// const bq5 = '/style/assets/image/p4/bq/hicetea5@2x.png'
	// const bq6 = '/style/assets/image/p4/bq/hicetea6@2x.png'
	// const bq7 = '/style/assets/image/p4/bq/hicetea7@2x.png'
	// const bq8 = '/style/assets/image/p4/bq/hicetea8@2x.png'
	// const bq9 = '/style/assets/image/p4/bq/hicetea9@2x.png'
	// const bq10 = '/style/assets/image/p4/bq/hicetea10@2x.png'
	// const bq11 = '/style/assets/image/p4/bq/hicetea11@2x.png'
	// const bq12 = '/style/assets/image/p4/bq/hicetea12@2x.png'
	// 测试
	const bq1 = '/style/assets/image/p4/bq/01.png'
	const bq2 = '/style/assets/image/p4/bq/02.png'
	const bq3 = '/style/assets/image/p4/bq/03.png'
	const bq4 = '/style/assets/image/p4/bq/04.png'
	const bq5 = '/style/assets/image/p4/bq/05.png'
	const bq6 = '/style/assets/image/p4/bq/06.png'
	const bq7 = '/style/assets/image/p4/bq/07.png'
	const bq8 = '/style/assets/image/p4/bq/08.png'
	const bq9 = '/style/assets/image/p4/bq/09.png'
	const bq10 = '/style/assets/image/p4/bq/10.png'
	const bq11 = '/style/assets/image/p4/bq/11.png'
	const bq12 = '/style/assets/image/p4/bq/12.png'
	import { VueCropper } from 'vue-cropper'
	import html2canvas from 'html2canvas'
	import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
	import mapCanvasVue from '../components/mapCanvas.vue'
	import 'swiper/css/swiper.css'
	export default {
		components: {
			VueCropper,
			Swiper,
			SwiperSlide,
			mapCanvasVue,
		},
		data() {
			return {
				xkImg: '',
				avatarImg: '',
				bqImg: '',
				currentUserAvatarImg: '',
				currentUserName: '',
				bqPosition: 'left',
				bqList: [
					{ id: 1, img: bq1, width: '', height: '' },
					{ id: 2, img: bq2, width: '', height: '' },
					{ id: 3, img: bq3, width: '', height: '' },
					{ id: 4, img: bq4, width: '', height: '' },
					{ id: 5, img: bq5, width: '', height: '' },
					{ id: 6, img: bq6, width: '', height: '' },
					{ id: 7, img: bq7, width: '', height: '' },
					{ id: 8, img: bq8, width: '', height: '' },
					{ id: 9, img: bq9, width: '', height: '' },
					{ id: 10, img: bq10, width: '', height: '' },
					{ id: 11, img: bq11, width: '', height: '' },
					{ id: 12, img: bq12, width: '', height: '' },
				],
				showBqList: [
					{
						id: 100,
						arr: [
							{ id: 1, img: bq1, width: '', height: '' },
							{ id: 2, img: bq2, width: '', height: '' },
							{ id: 3, img: bq3, width: '', height: '' },
							{ id: 4, img: bq4, width: '', height: '' },
							{ id: 5, img: bq5, width: '', height: '' },
							{ id: 6, img: bq6, width: '', height: '' },
						],
					},
					{
						id: 101,
						arr: [
							{ id: 7, img: bq7, width: '', height: '' },
							{ id: 8, img: bq8, width: '', height: '' },
							{ id: 9, img: bq9, width: '', height: '' },
							{ id: 10, img: bq10, width: '', height: '' },
							{ id: 11, img: bq11, width: '', height: '' },
							{ id: 12, img: bq12, width: '', height: '' },
						],
					},
					{
						id: 103,
						arr: [
							{ id: 1, img: bq1, width: '', height: '' },
							{ id: 2, img: bq2, width: '', height: '' },
							{ id: 3, img: bq3, width: '', height: '' },
							{ id: 4, img: bq4, width: '', height: '' },
							{ id: 5, img: bq5, width: '', height: '' },
							{ id: 6, img: bq6, width: '', height: '' },
						],
					},
					{
						id: 104,
						arr: [
							{ id: 7, img: bq7, width: '', height: '' },
							{ id: 8, img: bq8, width: '', height: '' },
							{ id: 9, img: bq9, width: '', height: '' },
							{ id: 10, img: bq10, width: '', height: '' },
							{ id: 11, img: bq11, width: '', height: '' },
							{ id: 12, img: bq12, width: '', height: '' },
						],
					},
					{
						id: 105,
						arr: [
							{ id: 1, img: bq1, width: '', height: '' },
							{ id: 2, img: bq2, width: '', height: '' },
							{ id: 3, img: bq3, width: '', height: '' },
							{ id: 4, img: bq4, width: '', height: '' },
							{ id: 5, img: bq5, width: '', height: '' },
							{ id: 6, img: bq6, width: '', height: '' },
						],
					},
					{
						id: 106,
						arr: [
							{ id: 7, img: bq7, width: '', height: '' },
							{ id: 8, img: bq8, width: '', height: '' },
							{ id: 9, img: bq9, width: '', height: '' },
							{ id: 10, img: bq10, width: '', height: '' },
							{ id: 11, img: bq11, width: '', height: '' },
							{ id: 12, img: bq12, width: '', height: '' },
						],
					},
				],
				isIOS: false,
				uploadModal: false,
				showCropper: false,
				option: {
					img: '',
					outputSize: 1,
					info: true, // 裁剪框的大小信息
					outputType: 'png', // 裁剪生成图片的格式
					canScale: false, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					// autoCropWidth: window.innerWidth - 200 + 'px', // 默认生成截图框宽度
					// autoCropHeight: window.innerWidth - 200 + 'px', // 默认生成截图框高度
					autoCropWidth: 0, // 默认生成截图框宽度
					autoCropHeight: 0, // 默认生成截图框高度
					high: true, // 是否按照设备的dpr 输出等比例图片
					fixedBox: false, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1], // 截图框的宽高比例
					full: true, // 是否输出原图比例的截图
					canMoveBox: true, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
					mode: '300px auto', // 图片默认渲染方式
					enlarge: 0.5,
				},
				xkHeight: '80%',
				xkWidth: '80%',
				xkTop: '',
				xkLeft: '',
				xkSpecial: false,
				bqActiveIndex: 1,
				swiperOption: {
					loop: false,
					speed: 1000,
					autopaly: {
						delay: 3000,
						disableOnInteraction: false,
					},
					effect: 'slide',
					navigation: {
						nextEl: 'right-btn',
						preEl: 'left-btn',
					},
				},
				jumpFlag: true,
				bqImgId: '',
			}
		},
		created() {
			if (localStorage.getItem('avatarMaking')) {
				let data = JSON.parse(localStorage.getItem('avatarMaking'))
				this.avatarImg = data.avatarImg || ''
				this.bqImg = data.bqImg || ''
				this.bqImgId = data.bqImgId || ''
				this.xkImg = data.img
				this.bqPosition = data.position
				this.xkHeight = data.heigth
				this.xkWidth = data.width
				this.xkTop = data.top
				this.xkLeft = data.left
				this.xkSpecial = data.special || false
			} else {
				this.xkImg = this.$route.params.img
				this.bqPosition = this.$route.params.position
				this.xkHeight = this.$route.params.heigth
				this.xkWidth = this.$route.params.width
				this.xkTop = this.$route.params.top
				this.xkLeft = this.$route.params.left
				this.xkSpecial = this.$route.params.special || false
				localStorage.setItem(
					'avatarMaking',
					JSON.stringify({
						...this.$route.params,
						avatarImg: this.avatarImg,
						bqImg: this.bqImg,
						bqImgId: this.bqImgId,
					})
				)
			}
			this.getUserInfo()
		},
		mounted() {
			let u = navigator.userAgent
			this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
		},
		methods: {
			storageData(obj) {
				let data = JSON.parse(localStorage.getItem('avatarMaking'))
				localStorage.setItem(
					'avatarMaking',
					JSON.stringify({ ...data, ...obj })
				)
			},
			leftClick() {
				this.$refs.bqSwiperRef.$swiper.slidePrev()
			},
			rightClick() {
				this.$refs.bqSwiperRef.$swiper.slideNext()
			},
			checkIsIoS() {
				//点击头像调用的方法
				if (!this.isIOS) {
					//非IOS则显示自定义弹框
					this.uploadModal = true
				} else {
					this.$refs.inputFileRefIOS.click() //IOS选择文件，触发changeImgIOS方法
				}
			},
			getUserInfo() {
				let vdata = localStorage.getItem('vdata')
				if (!vdata || vdata === 'none') {
					if (vdata === 'none') {
						let obj = this.$common.getRequest()
						vdata = obj['vdata']
					} else {
						this.$toast('用户头像获取失败')
						return
					}
				}
				let formData = new FormData()
				formData.append('way', 'min')
				formData.append('vdata', vdata)
				this.$http
					.post(`${this.$BASE_URL}/_vip`, formData, {
						headers: { 'content-type': 'application/x-www-form-urlencoded' },
					})
					.then(res => {
						if (res.data && res.data.error == 0) {
							this.currentUserAvatarImg = res.data.data.img
							// this.avatarImg = this.currentUserAvatarImg
							this.currentUserName = res.data.data.uname
						} else {
							this.$toast('用户头像获取失败')
							localStorage.setItem('vdata', 'none')
							let index = window.location.href.indexOf('?')
							let path = window.location.href
							if (index != -1) {
								path = window.location.href.substring(0, index)
							}
							window.location.replace(
								`${this.$BASE_URL}/?rurl=${path}#/avatar-making`
							)
						}
					})
					.catch(error => {
						console.log(error)
						localStorage.setItem('vdata', 'none')
						this.$toast('用户头像获取失败')
						let index = window.location.href.indexOf('?')
						let path = window.location.href
						if (index != -1) {
							path = window.location.href.substring(0, index)
						}
						window.location.replace(
							`${this.$BASE_URL}/?rurl=${path}#/avatar-making`
						)
					})
			},
			useCurrentAvatar() {
				// this.avatarImg = this.currentUserAvatarImg
				this.option.img = ''
				let _self = this
				let img = new Image()
				img.setAttribute('crossOrigin', 'anonymous')
				img.src = this.currentUserAvatarImg
				img.onload = () => {
					let img64 = _self.compress(img, 1)
					this.avatarImg = img64
					this.storageData({ avatarImg: this.avatarImg })
					_self.option.img = img64
				}
			},
			uploadImg() {
				this.uploadModal = true
				// TODU
			},
			handleImg(img64, ratio) {
				debugger
				let img = new Image()
				img.src = img64
				let self = this
				img.onload = () => {
					console.log(ratio)
					let width = img.width
					let height = img.height
					if (img.width * ratio >= window.innerWidth - 100) {
						if (img.width * ratio < img.height) {
							height = window.innerWidth - 110
							width = window.innerWidth - 110
						} else {
							if (img.height * ratio > window.innerWidth - 100) {
								height = window.innerWidth - 110
								width = window.innerWidth - 110
							} else {
								height = img.height * ratio
								width = img.height * ratio
							}
						}
					} else {
						if (img.width * ratio > img.height * ratio) {
							height = img.height * ratio
							width = img.height * ratio
						} else {
							height = img.width * ratio
							width = img.width * ratio
						}
					}
					self.option.autoCropWidth = width + 'px' //改变上传的图片像素，缩放至原来的0.6
					self.option.autoCropHeight = height + 'px'
				}
			},
			callBack() {
				this.jumpFlag = false
				localStorage.removeItem('avatarMaking')
				this.$router.replace('/frame-selection')
			},
			bqImgSelect(item) {
				if (this.bqImgId == item.id) {
					this.bqImg = ''
					this.bqImgId = ''
				} else {
					this.bqImg = item.img
					this.bqImgId = item.id
				}
				this.storageData({ bqImg: this.bqImg, bqImgId: this.bqImgId })
			},
			openFile(type) {
				if (type == 2) {
					this.$refs.inputFileRef.click()
				} else {
					this.$refs.inputFilCameraeRef.click()
				}
			},
			changeImg(type) {
				this.uploadModal = false
				let file = null
				if (type == 1) {
					file = this.$refs.inputFilCameraeRef.files[0] //相机拍照的
				} else {
					file = this.$refs.inputFileRef.files[0] //相册选择的
				}
				// this.showCropper = true
				this.imageToBase64(file)
			},
			changeImgIOS() {},
			imageToBase64(file) {
				this.option.img = '' //清空上一次裁剪的图片
				let reader = new FileReader()
				reader.readAsDataURL(file)
				reader.onload = () => {
					if (file.size > 0) {
						//大于 1M 的图片压缩
						let scaleSize = 0.9 //定义压缩的比例（程度）
						let image = new Image()
						image.src = reader.result
						image.onload = () => {
							if (
								file.size > 1 * 1024 * 1024 &&
								file.size < 2 * 1024 * 1024 + 1
							) {
								//1-2M
								scaleSize = 0.9
							}
							if (
								file.size > 2 * 1024 * 1024 &&
								file.size < 3 * 1024 * 1024 + 1
							) {
								//2-3M
								scaleSize = 0.9
							}
							if (
								file.size > 3 * 1024 * 1024 &&
								file.size < 4 * 1024 * 1024 + 1
							) {
								//3-4M
								scaleSize = 0.9
							}
							if (file.size > 4 * 1024 * 1024) {
								//4M+
								scaleSize = 0.9
							}

							// let img64 = this.compress(image, scaleSize)
							let img64 = this.compress(image, 1)
							this.avatarImg = img64
							this.storageData({ avatarImg: this.avatarImg })
							// this.option.img = img64
						}
					} else {
						this.option.img = reader.result
					}
				}
				reader.onerror = error => {
					console.log(error)
				}
			},
			compress(img, ratio) {
				//图片压缩并转化为base64返回
				let canvas, ctx, img64
				let width = img.width * 1 //改变上传的图片像素，缩放至原来的0.6
				let height = img.height * 1
				canvas = document.createElement('canvas')
				// canvas.background = '#fff'
				canvas.width = width
				canvas.height = height
				canvas.style.background = 'transparent'
				ctx = canvas.getContext('2d')
				ctx.drawImage(img, 0, 0, width, height)
				img64 = canvas.toDataURL('image/jpeg', ratio)
				this.handleImg(img64, ratio)
				return img64
			},
			// 裁剪完成
			getCropBlob() {
				this.$toast.loading({
					duration: 0,
					forbidClick: true,
					message: '加载中',
				})
				this.$refs.cropper.getCropBlob(async data => {
					this.avatarImg = window.URL.createObjectURL(data)
					this.showCropper = false //隐藏裁剪遮罩
					this.$toast.clear()
					console.log(data)
				})
			},
			// 取消裁剪
			cancelCropper() {
				this.showCropper = false
			},

			imatateDownloadByA(href, filename) {
				const a = document.createElement('a')
				a.download = filename
				a.style.display = 'none'
				a.href = href
				document.body.appendChild(a)
				a.click()
				a.remove()
				window.URL.revokeObjectURL(href)
			},

			// 生成头像
			generateNewAvatar() {
				// const targetDom = this.$refs.data1BoxRef
				if (!this.avatarImg) {
					this.$toast('请上传图片后生成头像')
					return
				}
				this.$toast.loading({
					duration: 0,
					forbidClick: true,
					message: '头像生成中请稍后...',
				})
				this.$nextTick(() => {
					this.createdCvs()
				})
			},
			getPixelRatio(context) {
				// 获取设备的PixelRatio
				var backingStore =
					context.backingStorePixelRatio ||
					context.webkitBackingStorePixelRatio ||
					context.mozBackingStorePixelRatio ||
					context.msBackingStorePixelRatio ||
					context.oBackingStorePixelRatio ||
					context.backingStorePixelRatio ||
					1
				return (window.devicePixelRatio || 1) / backingStore
			},

			createdCvs() {
				this.$refs.mapCnavasRef.generateImg(true)
				const targetDom = this.$refs.data1BoxRef
				let _self = this
				let canvas = document.createElement('canvas')
				let context = canvas.getContext('2d')
				let width = targetDom.offsetWidth || 230
				let height = targetDom.offsetHeight || 240
				let scale = this.getPixelRatio(context) //将canvas的容器扩大PixelRatio倍，再将画布缩放，将图像放大PixelRatio倍。
				// canvas.width = width * scale
				// canvas.height = height * scale
				canvas.width = width * scale
				canvas.height = height * scale
				canvas.style.width = width + 'px'
				canvas.style.height = height + 'px'
				canvas.style.background = 'transparent'
				html2canvas(targetDom, {
					dpi: 300,
					width: width,
					height: height,
					backgroundColor: null,
					allowTaint: true,
					useCORS: true,
					canvas: canvas,
				}).then(canvas => {
					document.querySelector('#box1').appendChild(canvas)
					console.log(canvas.toDataURL('image/png', 1))
					localStorage.setItem('canvasImg', canvas.toDataURL('image/png', 1))
					this.$refs.mapCnavasRef.generateImg(false)
					_self.saveImgInServer(canvas.toDataURL('image/png', 1))
				})
			},
			// 上传服务器
			saveImgInServer(imgUrl) {
				let vdata = localStorage.getItem('vdata')
				let formData = new FormData()
				formData.append('way', 'save')
				formData.append('vdata', vdata)
				formData.append('img', imgUrl)
				this.$http
					.post(`${this.$BASE_URL}/_vip`, formData, {
						headers: { 'content-type': 'application/x-www-form-urlencoded' },
					})
					.then(res => {
						this.$toast.clear()
						if (res.data && res.data.error == 0) {
							this.jumpFlag = false
							this.$router.replace({
								name: 'avatarSharing',
								params: { uname: this.currentUserName },
							})
						} else {
							this.avatarImg = ''
							this.$toast('检测到您上传的内容包含非法信息请核对后重新上传')
						}
					})
					.catch(err => {
						console.log(err)
						this.avatarImg = ''
						this.$toast.clear()
						this.$toast('检测到您上传的内容包含非法信息请核对后重新上传')
					})
			},
		},
	}
</script>
<style lang="scss" scoped>
	@keyframes Breathing {
		0% {
			transform: scale(1.15);
		}
		25% {
			transform: scale(1.1);
		}
		50% {
			transform: scale(1.05);
		}
		100% {
			transform: scale(1);
		}
	}
	.fs-container {
		z-index: 100;
		width: 10rem;
		height: calc(100vh - 2.133333rem);
		background: url('/style/assets/image/p4/bg.png') #e7343a
			no-repeat;
		background-size: 100% 16.8rem;
		padding-top: 2.133333rem;
		div,
		img {
			user-select: none;
			-webkit-appearance: none !important;
		}
		.content-show-box {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			.img-s-box {
				width: 5.466667rem;
				height: 5.466667rem;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
				border-radius: 10px;
				// background-color: #ffffff;
				.add-i {
					width: 1.56rem;
					height: 1.56rem;
					// background: url('/style/assets/image/p4/add.png')
					// 	no-repeat;
					// background-size: 100% 100%;
				}
				.bqbj-cla {
					position: absolute;
					height: 100%;
					width: 100%;
					top: 0;
					left: 0;
					pointer-events: none;
					z-index: 1;
				}
				.bq-cla {
					position: absolute;
					width: 50%;
					bottom: 5%;
					z-index: 2;
					pointer-events: none;
					max-height: 1.7rem;
				}
				.txx-img {
					position: absolute;
					z-index: 0;
				}
				.left {
					left: 5%;
				}
				.right {
					right: 5%;
				}
				.xygb-bq-img {
					width: 35%;
				}
				.fl-bq-img {
					height: 0.6rem;
				}
				.ayg-bq-img {
					height: 1.3rem;
					width: 2.4rem;
				}
			}
			.special-img {
				width: 7rem;
				left: -0.7rem;
			}
			.opt-btns {
				width: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-bottom: 0.333333rem;
				.up-btn {
					width: 5.066667rem;
					height: 1.333333rem;
				}
				.up-btn:nth-child(1) {
					background: url('/style/assets/image/p4/current-tx.png')
						no-repeat;
					background-size: 100% 100%;
				}
				.up-btn:nth-child(2) {
					background: url('/style/assets/image/p4/upload-btn.png')
						no-repeat;
					background-size: 100% 100%;
				}
			}
			.select-box {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				.left-btn {
					height: 1.2rem;
					width: 0.826667rem;
					background: url('/style/assets/image/left-btn.png')
						no-repeat;
					background-size: 100% 100%;
					-webkit-animation: Breathing 1s 2s both infinite;
					-moz-animation: Breathing 1s 2s both infinite;
					-ms-animation: Breathing 1s 2s both infinite;
					animation: Breathing 1s 2s both infinite;
				}
				.right-btn {
					// height: 0.466667rem;
					// width: 0.4rem;
					height: 1.2rem;
					width: 0.826667rem;
					background: url('/style/assets/image/right-btn.png')
						no-repeat;
					background-size: 100% 100%;
					-webkit-animation: Breathing 1s 2s both infinite;
					-moz-animation: Breathing 1s 2s both infinite;
					-ms-animation: Breathing 1s 2s both infinite;
					animation: Breathing 1s 2s both infinite;
				}
				.sb-box {
					height: 3.816667rem;
					// width: 8.133333rem;
					width: 7.2rem;
					background: url('/style/assets/image/p4/bqxz-bg.png')
						no-repeat;
					background-size: 102% 100%;
					display: flex;
					justify-content: center;
					padding-top: 1.25rem;
					.sb-cbox-warper {
						width: 6rem;
						display: flex;
						justify-content: center;
						// margin-left: 0.5rem;
						position: relative;
						.sb-box-wapper {
							height: 3.1rem;
							// width: 6.6rem;
							width: 6rem;
							background: url('/style/assets/image/p4/fgx-bg.png')
								no-repeat;
							background-size: 100% 100%;
							display: flex;
							flex-wrap: wrap;
							.img-c {
								width: calc(33.3% - 0.266666rem);
								height: calc(50% - 0.266666rem);
								display: flex;
								align-items: center;
								justify-content: center;
								padding: 0.133333rem;
								img {
									height: 60%;
									width: 80%;
								}
							}
						}
					}
				}
			}
			.end-btns {
				height: 1.2rem;
				width: 100%;
				display: flex;
				justify-content: center;
				.btn {
					height: 100%;
				}
				.btn:nth-child(1) {
					width: 2.266667rem;
					margin-right: 0.666667rem;
					background: url('/style/assets/image/p4/callback-btn.png')
						no-repeat;
					background-size: 100% 100%;
				}
				.btn:nth-child(2) {
					width: 3.6rem;
					background: url('/style/assets/image/p4/sc-btn.png')
						no-repeat;
					background-size: 100% 100%;
				}
			}
		}
		.popup-box {
			width: 100%;
			display: flex;
			flex-direction: column;
			font-size: 20px;
			padding-top: 10px;
			div {
				height: 40px;
				text-align: center;
			}
		}
	}
</style>
